import { Card, Col, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import { LoginContainer } from "../../components";
import AppFooter from "../../constants/layout/footer";

const { Text } = Typography;

const TermsOfService = () => {
    return (
        <LoginContainer>
            <Row justify="center" align="middle">
                <Card style={{ width: "90%" }}>
                    <Row style={{ marginTop: "2em" }}>
                        <Col span={4}></Col>
                        <Col span={16}>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                <Text style={{ fontSize: "2.5em", fontWeight: "bolder" }}>
                                    Appbox Terms Of Service
                                </Text>
                            </Row>
                            <Row
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginBottom: "1em",
                                }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: "lighter" }}>
                                    Last Modified: October 4, 2023
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Welcome to Appbox, the website and online service of Appbox Di
                                    Cama Claudio (“Appbox,” “we,” or “us”). This page explains the
                                    terms by which you may use our online services, web site,
                                    software, cloud computing platform, APIs, and all other services
                                    under Appbox’s control, provided on or in connection with the
                                    service (collectively, the “Service”). By accessing or using the
                                    Service, or by clicking a button or checking a box marked “I
                                    Agree” (or something similar), you signify that you have read,
                                    understood, and agree to be bound by these Terms of Service
                                    (this “Agreement”), our{" "}
                                    <Link to={"/acceptabe_use"}>Acceptable Use Policy</Link>, and to
                                    the collection and use of your information as set forth in our{" "}
                                    <Link to={"/privacy"}>Privacy Policy</Link>, whether or not you
                                    are a registered user of our Service. Appbox reserves the right
                                    to modify these terms and will provide notice of these changes
                                    as described below. This Agreement applies to all visitors,
                                    users, and others who access the Service (“Users”). Please read
                                    this Agreement carefully to ensure that you understand each
                                    provision. This agreement contains a mandatory individual
                                    arbitration and class action/jury trial waiver provision that
                                    requires the use of arbitration on an individual basis to
                                    resolve disputes, rather than jury trials or class actions.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    1. Our Service
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    1.1 Eligibility This is a contract between you and Appbox. You
                                    must read and agree to these terms before using the Appbox
                                    Service. If you do not agree, you may not use the Service. You
                                    may use the Service only if you can form a binding contract with
                                    Appbox, and only in compliance with this Agreement and all
                                    applicable local, state, national, and international laws, rules
                                    and regulations. You are responsible for the acts of others
                                    utilizing your access to the Service and will be held
                                    responsible for violations of the Service by persons who gain
                                    access to the Service using your account or shared access. Any
                                    use or access to the Service by anyone under 16 is strictly
                                    prohibited and in violation of this Agreement. The Service is
                                    not available to any Users previously removed from the Service
                                    by Appbox. 1.2 Limited License Subject to the terms and
                                    conditions of this Agreement, you are hereby granted a
                                    non-exclusive, limited, non-transferable, non-sublicensable,
                                    freely revocable license to use the Service for own use only and
                                    as permitted by the features of the Service. Appbox reserves all
                                    rights not expressly granted herein in the Service and the
                                    Appbox Content (as defined below). Appbox may terminate this
                                    license at any time for any reason or no reason. 1.3 User
                                    Accounts Your account on the Service (your “User Account”) gives
                                    you access to the services and functionality that we may
                                    establish and maintain from time to time and in our sole
                                    discretion. We may maintain different types of User Accounts for
                                    different types of Users. If you open a User Account on behalf
                                    of a company, organization, or other entity, then (i) “you”
                                    includes you and that entity, and (ii) you represent and warrant
                                    that you are an authorized representative of the entity with the
                                    authority to bind the entity to this Agreement, and that you
                                    agree to this Agreement on the entity’s behalf. By connecting to
                                    Company with a third-party service, you give us permission to
                                    access and use your information from that service as permitted
                                    by that service, and to store your log-in credentials for that
                                    service. You may never use another User’s User Account without
                                    permission. When creating your User Account, you must provide
                                    accurate and complete information, and you must keep this
                                    information up to date. You are solely responsible for the
                                    activity that occurs on your User Account, and you must keep
                                    your User Account password secure. We encourage you to use
                                    strong passwords (unguessable passwords of sufficient length and
                                    entropy) with your User Account. You must notify Appbox
                                    immediately of any breach of security or unauthorized use of
                                    your User Account. Appbox will not be liable for any losses
                                    caused by any unauthorized use of your User Account. By
                                    providing Appbox your email address you consent to our using the
                                    email address to send you Service-related notices, including any
                                    notices required by law, in lieu of communication by postal
                                    mail. We may also use your email address to send you other
                                    messages, such as changes to features of the Service and special
                                    offers. Opting out may prevent you from receiving email messages
                                    regarding updates, improvements, or offers. 1.4 Acceptable Use
                                    Appbox’s Acceptable Use Policy is hereby incorporated by
                                    reference. 1.5 Changes to the Service We may, without prior
                                    notice, change the Service; stop providing the Service or
                                    features of the Service, to you or to Users generally; or create
                                    usage limits for the Service. We may permanently or temporarily
                                    terminate or suspend your access to the Service without notice
                                    and liability for any reason, including if in our sole
                                    determination you violate any provision of this Agreement, or
                                    for no reason. Upon termination for any reason or no reason, you
                                    continue to be bound by this Agreement. 1.6 Disputes with Other
                                    Users You are solely responsible for your interactions with
                                    other Users. We reserve the right, but have no obligation, to
                                    monitor disputes between you and other Users. Appbox shall have
                                    no liability for your interactions with other Users, or for any
                                    User’s action or inaction.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    2. User Content
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    The Service allows Users to submit, post, display, provide, or
                                    otherwise make available content such as profile information,
                                    comments, questions, source code, logs, and other content or
                                    information (any such materials a User submits, posts, displays,
                                    provides, or otherwise makes available on the Service is
                                    referred to as “User Content”). We claim no ownership rights
                                    over User Content created by you. The User Content you create
                                    remains yours. Company has the right (but not the obligation) in
                                    its sole discretion to monitor and/or remove any User Content on
                                    the Service. This includes, without limitation, User Content
                                    that violates these terms or our Acceptable Use Policy. For the
                                    purposes of this Agreement, “Intellectual Property Rights” means
                                    all patent rights, copyright rights, mask work rights, moral
                                    rights, rights of publicity, trademark, trade dress and service
                                    mark rights, goodwill, trade secret rights and other
                                    intellectual property rights as may now exist or hereafter come
                                    into existence, and all applications therefore and
                                    registrations, renewals and extensions thereof, under the laws
                                    of any state, country, territory or other jurisdiction. In
                                    connection with your User Content, you affirm, represent and
                                    warrant the following: You have obtained and are solely
                                    responsible for obtaining all consents as may be required by law
                                    to post any User Content relating to third parties. Your User
                                    Content and Appbox’s use thereof as contemplated by this
                                    Agreement and the Service will not violate any law or infringe
                                    any rights of any third party, including but not limited to any
                                    Intellectual Property Rights and privacy rights. Appbox takes no
                                    responsibility and assumes no liability for any User Content
                                    that you or any other User or third-party posts, sends, or
                                    otherwise makes available over the Service. You shall be solely
                                    responsible for your User Content and the consequences of
                                    posting, publishing it, sharing it, or otherwise making it
                                    available on the Service, and you agree that we are only acting
                                    as a passive conduit for your online distribution and
                                    publication of your User Content. You understand and agree that
                                    you may be exposed to User Content that is inaccurate,
                                    objectionable, inappropriate for children, or otherwise unsuited
                                    to your purpose, and you agree that Appbox shall not be liable
                                    for any damages you allege to incur as a result of or relating
                                    to any User Content.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    3. Our Proprietary Rights
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Except for your User Content, the Service and all materials
                                    therein or transferred thereby, including, without limitation,
                                    software, images, text, graphics, illustrations, logos, patents,
                                    trademarks, service marks, copyrights, photographs, audio,
                                    videos, music, and User Content belonging to other Users (the
                                    “Appbox Content”), and all Intellectual Property Rights related
                                    thereto, are the exclusive property of Appbox and its licensors
                                    (including other Users who post User Content to the Service).
                                    Except as explicitly provided herein, nothing in this Agreement
                                    shall be deemed to create a license in or under any such
                                    Intellectual Property Rights, and you agree not to sell,
                                    license, rent, modify, distribute, copy, reproduce, transmit,
                                    publicly display, publicly perform, publish, adapt, edit or
                                    create derivative works from any Appbox Content. Use of the
                                    Appbox Content for any purpose not expressly permitted by this
                                    Agreement is strictly prohibited. You may choose to or we may
                                    invite you to submit comments or ideas about the Service,
                                    including without limitation about how to improve the Service or
                                    our products (“Ideas”). By submitting any Idea, you agree that
                                    your disclosure is gratuitous, unsolicited and without
                                    restriction and will not place Appbox under any fiduciary or
                                    other obligation, and that we are free to use the Idea without
                                    any additional compensation to you, and/or to disclose the Idea
                                    on a non-confidential basis or otherwise to anyone. You further
                                    acknowledge that, by acceptance of your submission, Appbox does
                                    not waive any rights to use similar or related ideas previously
                                    known to Appbox, or developed by its employees, or obtained from
                                    sources other than you. The Service contains data, information,
                                    and other content not owned by you, such as credits offered by
                                    Appbox (“Appbox Property”). You understand and agree that
                                    regardless of terminology used, Appbox Property represents a
                                    limited license right governed solely by the terms of this
                                    Agreement and available for distribution at Appbox’s sole
                                    discretion. Appbox Property is not redeemable for any sum of
                                    money or monetary value from Appbox at any time. You acknowledge
                                    that you do not own the User Account you use to access the
                                    Service, nor do you possess any rights of access or rights to
                                    data stored by or on behalf of Appbox on Appbox servers,
                                    including without limitation any data representing or embodying
                                    any or all of your Appbox Property. You agree that Appbox has
                                    the absolute right to manage, regulate, control, modify and/or
                                    eliminate Appbox Property as it sees fit in its sole discretion,
                                    in any general or specific case, and that Appbox will have no
                                    liability to you based on its exercise of such right. All data
                                    on Appbox’s servers are subject to deletion, alteration or
                                    transfer. Notwithstanding any value attributed to such data by
                                    you or any third party, you understand and agree that any data,
                                    User Account history and User Account content residing on
                                    Appbox’s servers, may be deleted, altered, moved or transferred
                                    at any time for any reason in Appbox’s sole discretion, with or
                                    without notice and with no liability of any kind. Appbox does
                                    not provide or guarantee, and expressly disclaims, any value,
                                    cash or otherwise, attributed to any data residing on Appbox’s
                                    servers.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    4. Paid Services
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Billing Policies. Certain aspects of the Service may be provided
                                    for a fee or other charge. Appbox may add new services for
                                    additional fees and charges, add or amend fees and charges for
                                    existing services, at any time in its sole discretion. Any
                                    change to our Pricing or Payment Terms shall become effective in
                                    the billing cycle following notice of such change to you as
                                    provided in this Agreement. We use Stripe as our third-party
                                    service provider for payment services. By using our Service, you
                                    agree to be bound by Stripe’s Services Agreement available at
                                    https://stripe.com/us/legal. No Refunds. You may cancel your
                                    User Account at any time; however, there are no refunds for
                                    cancellation. In the event that Appbox suspends or terminates
                                    your User Account or this Agreement, you understand and agree
                                    that you shall receive no refund or exchange for any Appbox
                                    Property, any unused time on a subscription, any license or
                                    subscription fees for any portion of the Service, any content or
                                    data associated with your User Account, or for anything else.
                                    You are solely responsible for exporting your User Content from
                                    the Service prior to termination of your account for any reason.
                                    Payment Information; Taxes. All information that you provide in
                                    connection with a purchase or transaction or other monetary
                                    transaction interaction with the Service must be accurate,
                                    complete, and current. You agree to pay all charges incurred by
                                    users of your credit card, debit card, or other payment method
                                    used in connection with a purchase or transaction or other
                                    monetary transaction interaction with the Service at the prices
                                    in effect when such charges are incurred.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    5. No Professional Advice
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    If the Service provides professional information (for example,
                                    legal or financial), such information is for informational
                                    purposes only and should not be construed as professional
                                    advice. No action should be taken based upon any information
                                    contained in the Service. You should seek independent
                                    professional advice from a person who is licensed and/or
                                    qualified in the applicable area.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    6. Privacy
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    We care about the privacy of our Users. You understand that by
                                    using the Services you consent to the collection, use and
                                    disclosure of your personally identifiable information and
                                    aggregate and/or anonymized data as set forth in our Privacy
                                    Policy
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    7. Security
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Appbox cares about the integrity and security of your personal
                                    information. Appbox uses commercially reasonable physical,
                                    managerial, and technical safeguards to preserve the integrity
                                    and security of your personal information and implement your
                                    privacy settings. However, we cannot guarantee that unauthorized
                                    third parties will never be able to defeat our security measures
                                    or use your personal information for improper purposes. You
                                    acknowledge that you provide your personal information at your
                                    own risk.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    8. Third-Party Links and Information
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    The Service may contain links to third-party materials that are
                                    not owned or controlled by Appbox. Appbox does not endorse or
                                    assume any responsibility for any such third-party sites,
                                    information, materials, products, or services. If you access a
                                    third-party website or service from the Service or share your
                                    User Content on or through any third-party website or service,
                                    you do so at your own risk, and you understand that this
                                    Agreement and Appbox’s Privacy Policy do not apply to your use
                                    of such sites. You expressly relieve Appbox from any and all
                                    liability arising from your use of any third-party website,
                                    service, or content, including without limitation User Content
                                    submitted by other Users. Additionally, your dealings with or
                                    participation in promotions of advertisers found on the Service,
                                    including payment and delivery of goods, and any other terms
                                    (such as warranties) are solely between you and such
                                    advertisers. You agree that Appbox shall not be responsible for
                                    any loss or damage of any sort relating to your dealings with
                                    such advertisers.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    9. Indemnity
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    You agree to defend, indemnify and hold harmless Appbox and its
                                    subsidiaries, agents, licensors, managers, and other affiliated
                                    companies, and their employees, contractors, agents, officers
                                    and directors, from and against any and all claims, damages,
                                    obligations, losses, liabilities, costs or debt, and expenses
                                    (including but not limited to attorney’s fees) arising from: (i)
                                    your use of and access to the Service, including any data or
                                    content transmitted or received by you; (ii) your violation of
                                    any term of this Agreement, including without limitation your
                                    breach of any of the representations and warranties above; (iii)
                                    your violation of any third-party right, including without
                                    limitation any right of privacy or Intellectual Property Rights;
                                    (iv) your violation of any applicable law, rule or regulation;
                                    (v) User Content or any content that is submitted via your User
                                    Account including without limitation misleading, false, or
                                    inaccurate information; (vi) your willful misconduct; or (vii)
                                    any other party’s access and use of the Service with your unique
                                    username, password or other appropriate security code.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    10. No Warranty
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    The Service is provided on an “as is” and “as available” basis.
                                    Use of the Service is at your own risk. To the maximum extent
                                    permitted by applicable law, the Service is provided without
                                    warranties of any kind, whether express or implied, including,
                                    but not limited to, implied warranties of merchantability,
                                    fitness for a particular purpose, or non-infringement. No advice
                                    or information, whether oral or written, obtained by you from
                                    Appbox or through the Service will create any warranty not
                                    expressly stated herein. Without limiting the foregoing, Appbox,
                                    its subsidiaries, its affiliates, and its licensors do not
                                    warrant that the content is accurate, reliable or correct; that
                                    the Service will meet your requirements; that the Service will
                                    be available at any particular time or location, uninterrupted
                                    or secure; that any defects or errors will be corrected; or that
                                    the Service is free of viruses or other harmful components. Any
                                    content downloaded or otherwise obtained through the use of the
                                    Service is downloaded at your own risk and you will be solely
                                    responsible for any damage to your computer system or mobile
                                    device or loss of data that results from such download or your
                                    use of the Service. Further, Appbox does not warrant, endorse,
                                    guarantee, or assume responsibility for any product or service
                                    advertised or offered by a third party through the Service or
                                    any hyperlinked website or service, and Appbox will not be a
                                    party to or in any way monitor any transaction between you and
                                    third-party providers of products or services.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    11. Limitation of Liability
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    To the maximum extent permitted by applicable law, in no event
                                    shall Appbox, its affiliates, agents, directors, employees,
                                    suppliers or licensors be liable for any indirect, punitive,
                                    incidental, special, consequential or exemplary damages,
                                    including without limitation damages for loss of profits,
                                    goodwill, use, data or other intangible losses, arising out of
                                    or relating to the use of, or inability to use, the Service.
                                    Under no circumstances will Appbox be responsible for any
                                    damage, loss or injury resulting from hacking, tampering or
                                    other unauthorized access or use of the Service or your account
                                    or the information contained therein. To the maximum extent
                                    permitted by applicable law, Appbox assumes no liability or
                                    responsibility for any (i) errors, mistakes, or inaccuracies of
                                    content; (ii) personal injury or property damage, of any nature
                                    whatsoever, resulting from your access to or use of our service;
                                    (iii) any unauthorized access to or use of our secure servers
                                    and/or any and all personal information stored therein; (iv) any
                                    interruption or cessation of transmission to or from the
                                    Service; (v) any bugs, viruses, trojan horses, or the like that
                                    may be transmitted to or through our service by any third party;
                                    (vi) any errors or omissions in any content or for any loss or
                                    damage incurred as a result of the use of any content posted,
                                    emailed, transmitted, or otherwise made available through the
                                    Service; and/or (vii) User Content or the defamatory, offensive,
                                    or illegal conduct of any third party. This limitation of
                                    liability section applies whether the alleged liability is based
                                    on contract, tort, negligence, strict liability, or any other
                                    basis, even if Appbox has been advised of the possibility of
                                    such damage.
                                </Text>
                            </Row>
                            <Row style={{ display: "flex" }}>
                                {" "}
                                <Text
                                    style={{
                                        fontSize: "1.5em",
                                        fontWeight: "bolder",
                                        marginTop: "1em",
                                    }}>
                                    12. General
                                </Text>
                            </Row>
                            <Row style={{ display: "flex", justifyContent: "center" }}>
                                {" "}
                                <Text style={{ fontSize: "1.2em" }}>
                                    Assignment. This Agreement, and any rights and licenses granted
                                    hereunder, may not be transferred or assigned by you, but may be
                                    assigned by Appbox without restriction. Any attempted transfer
                                    or assignment in violation hereof shall be null and void.
                                    Notification Procedures and Changes to the Agreement. Appbox may
                                    provide notifications, whether such notifications are required
                                    by law or are for marketing or other business related purposes,
                                    to you via email notice, written or hard copy notice, or through
                                    posting of such notice on our website, as determined by Appbox
                                    in our sole discretion. Appbox reserves the right to determine
                                    the form and means of providing notifications to our Users,
                                    provided that you may opt out of certain means of notification
                                    as described in this Agreement. Appbox is not responsible for
                                    any automatic filtering you or your network provider may apply
                                    to email notifications we send to the email address you provide
                                    us. Appbox may, in its sole discretion, modify or update this
                                    Agreement from time to time, and so you should review this page
                                    periodically. When we change the Agreement in a material manner,
                                    we will update the ‘last modified’ date at the top of this page
                                    and notify you that material changes have been made to the
                                    Agreement. Your continued use of the Service after any such
                                    change constitutes your acceptance of the new Terms of Service.
                                    If you do not agree to any of these terms or any future Terms of
                                    Service, do not use or access (or continue to access) the
                                    Service. Entire Agreement/Severability. This Agreement, together
                                    with any amendments and any additional agreements you may enter
                                    into with Appbox in connection with the Service, shall
                                    constitute the entire agreement between you and Appbox
                                    concerning the Service. If any provision of this Agreement is
                                    deemed invalid by a court of competent jurisdiction, the
                                    invalidity of such provision shall not affect the validity of
                                    the remaining provisions of this Agreement, which shall remain
                                    in full force and effect, except that in the event of
                                    unenforceability of the universal Class Action/Jury Trial
                                    Waiver, the entire arbitration agreement shall be unenforceable.
                                    No Waiver. No waiver of any term of this Agreement shall be
                                    deemed a further or continuing waiver of such term or any other
                                    term, and Appbox’s failure to assert any right or provision
                                    under this Agreement shall not constitute a waiver of such right
                                    or provision. Contact. Please contact us at info@appbox.cloud
                                    with any questions regarding this Agreement.
                                </Text>
                            </Row>
                        </Col>
                        <Col span={4}></Col>
                    </Row>
                </Card>
            </Row>
            <AppFooter />
        </LoginContainer>
    );
};
export { TermsOfService };
